import {
  AppBar,
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
} from '@mui/material';

const FilterPanel = ({ activeFilter, setActiveFilter }) => {
  const handleActiveChange = (event) => {
    setActiveFilter(event.target.checked);
  };

  return (
    <AppBar
      variant="standard"
      position="sticky" // Add sticky position
      sx={{
        color: (theme) => theme.palette.text.primary,
        mb: 2,
        backgroundColor: 'transparent',
        zIndex: (theme) => theme.zIndex.appBar + 1, // Ensure it's above other content
      }}
    >
      <Box sx={{ display: 'flex', p: 0 }}>
        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox checked={activeFilter} onChange={handleActiveChange} />
            }
            label="Active"
          />
        </FormGroup>
      </Box>
      {/* <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={4} lg={3}>
          <ListItemText
            primary={'Billing Meter Health Check Job'}
            primaryTypographyProps={{
              fontSize: '0.8rem',
              color: 'text.secondary',
              mb: 0.5,
            }}
            secondary={
              <Chip
                icon={<AccessTimeRoundedIcon />}
                size="small"
                sx={{
                  borderRadius: 1,
                  mr: 1,
                  border: '1px solid',
                  borderColor: 'divider',
                }}
                label="At 30 minutes past the hour, every 6 hours, between 05:00 AM UTC and 11:59 PM UTC"
              />
            }
          />
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={3}>
          <ListItemText
            primary={'Gateway Health Check Job'}
            primaryTypographyProps={{
              fontSize: '0.8rem',
              color: 'text.secondary',
              mb: 0.5,
            }}
            secondary={
              <Chip
                icon={<AccessTimeRoundedIcon />}
                size="small"
                sx={{
                  borderRadius: 1,
                  mr: 1,
                  border: '1px solid',
                  borderColor: 'divider',
                }}
                label="At 0 minutes past the hour, every 6 hours, between 04:00 AM UTC and 11:59 PM UTC"
              />
            }
          />
        </Grid>

        <Grid item xs={12} sm={12} md={4} lg={3}>
          <ListItemText
            primary={'Sensor Health Check Job'}
            primaryTypographyProps={{
              fontSize: '0.8rem',
              color: 'text.secondary',
              mb: 0.5,
            }}
            secondary={
              <Chip
                icon={<AccessTimeRoundedIcon />}
                size="small"
                sx={{
                  borderRadius: 1,
                  mr: 1,
                  border: '1px solid',
                  borderColor: 'divider',
                }}
                label="At 30 minutes past the hour, every 6 hours, between 04:00 AM UTC and 11:59 PM UTC"
              />
            }
          />
        </Grid>

        <Grid item xs={12} sm={12} md={4} lg={3}>
          <ListItemText
            primary={'Service System Monitoring'}
            primaryTypographyProps={{
              fontSize: '0.8rem',
              color: 'text.secondary',
              mb: 0.5,
            }}
            secondary={
              <Chip
                icon={<AccessTimeRoundedIcon />}
                size="small"
                sx={{
                  borderRadius: 1,
                  mr: 1,
                  border: '1px solid',
                  borderColor: 'divider',
                }}
                label="At 07:15 AM GMT+2; At 09:15 AM GMT+2"
              />
            }
          />
        </Grid>
      </Grid> */}
    </AppBar>
  );
};

export default FilterPanel;
